import icons from "@assets/images/icons/icons";
import AuthService from "../services/auth-service";
import { encodeTokenForUrl } from '../common/utils';


const FINANCE_BASE_URL = process.env.REACT_APP_FINANCE_URL;
const EOC_BASE_URL = process.env.REACT_APP_EOC_URL;
const SCM_BASE_URL = process.env.REACT_APP_SCM_URL;
const POWER_BI_BASE_URL = process.env.REACT_APP_POWER_BI;
//const SUPPLIER_ADMIN_BASE_URL = process.env.REACT_APP_SUPPLIER_ADMIN;
const CRM_BASE_URL = process.env.REACT_APP_CRM;
const CREDIT_LIMIT_BASE_URL = process.env.REACT_APP_CREDIT_LIMIT;
const CATALOG_BASE_URL = process.env.REACT_APP_CATALOG_URL;
const BUSINESS_ID_FOR_SOB = process.env.REACT_APP_BUSINESS_ID_FOR_SOB;
const BUSINESS_ID_FOR_CRM = process.env.REACT_APP_BUSINESS_ID_FOR_CRM;
const BUSINESS_ID_FOR_SRM = process.env.REACT_APP_BUSINESS_ID_FOR_SRM;
const BUSINESS_ID_FOR_MNA = process.env.REACT_APP_BUSINESS_ID_FOR_MNA;
const BOARD_ID_FOR_SOB_CONTACTS = process.env.REACT_APP_BOARD_ID_FOR_SOB_CONTACTS;
//const BOARD_ID_FOR_SOB_ACCOUNT = process.env.REACT_APP_BOARD_ID_FOR_SOB_ACCOUNT;
//const BOARD_ID_FOR_SOB_PLANT = process.env.REACT_APP_BOARD_ID_FOR_SOB_PLANT;
const BOARD_ID_FOR_CRM_DEALS = process.env.REACT_APP_BOARD_ID_FOR_CRM_DEALS;
const BOARD_ID_FOR_CRM_ACCOUNT = process.env.REACT_APP_BOARD_ID_FOR_CRM_ACCOUNT;
const BOARD_ID_FOR_CRM_CONTACTS = process.env.REACT_APP_BOARD_ID_FOR_CRM_CONTACTS;
//const BOARD_ID_FOR_SOB_OPPORTUNITY = process.env.REACT_APP_BOARD_ID_FOR_SOB_OPPORTUNITY;
//const LANE_ID_FOR_HUNTING_ACCOUNT = process.env.REACT_APP_LANE_ID_FOR_HUNTING_ACCOUNT;
const BOARD_ID_FOR_SRM_SUPPLIER = process.env.REACT_APP_BOARD_ID_FOR_SRM_SUPPLIER;
const BOARD_ID_FOR_MNA_SUPPLIER = process.env.REACT_APP_BOARD_ID_FOR_MNA_SUPPLIER;

export const menu = [
  {
    label: 'Approvals',
    icon: icons.approval,
    url: () => '',
    bgColor: 'bg-[#C8F7E7]',
    menu: [
      {
        label: 'RFQ Approvals',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${EOC_BASE_URL}/pre-po/gm-approval/gm-approval-sheet${token ? `?token=${token}` : ''}`;
        },
        videoUrl: 'https://cdn.moglix.com/mogliverse/cm%20approval%20rfq%20and%20crmm.webm',
        menu: [],
      },
      {
        label: 'CPO Approvals',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${EOC_BASE_URL}/po/po-approval-sheet${token ? `?token=${token}` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
      {
        label: 'SPO Approvals',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${SCM_BASE_URL}/auth-validate/${token}${token ? `?tabgroup=SPOAPPROVALS&tabname=spoapprovals` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
      {
        label: 'LC & BG Approvals',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=lcbg` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
    ],
  },
  {
    label: 'Analytics & Reports',
    icon: icons.analytics,
    bgColor: 'bg-[#C1E7F1]',
    url: () => '',
    menu: [
      {
        label: 'Power BI',
        url: () => `${POWER_BI_BASE_URL}/home?experience=power-bi`,
        videoUrl: '',
        disable: false,
        menu: [],
      },
      {
        label: 'Analytics Web',
        url: () => `https://analytics-web m`,
        videoUrl: '',
        disable: false,
        menu: [],
      },
      {
        label: 'AOP & Targets',
        url: () => '',
        videoUrl: '',
        disable: true,
        menu: [],
      },
      {
        label: 'Score Cards',
        url: () => `https://app.powerbi.com/groups/23297ace-d9b3-4a38-8630-61a58f4b4685/reports/81d7783c-449f-44bc-a8f0-f340b77a41f2?ctid=421e9584-87ff-424f-95b8-1bf46b70db99&pbi_source=linkShare`,
        videoUrl: '',
        disable: true,
        menu: [],
      },
    ],
  },
  {
    label: 'Order Management',
    icon: icons.orderManagement,
    bgColor: 'bg-[#F5C9DB]',
    url: () => '',
    menu: [
      {
        label: 'Customer Order Management',
        url: () => '',
        videoUrl: '',
        menu: [
          {
            label: 'RFQ Management',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${EOC_BASE_URL}/pre-po/rfq-sheet${token ? `?token=${token}` : ''}`;
            },
            videoUrl: 'https://cdn.moglix.com/mogliverse/3.2RFQ_tracking_on_EOC.mp4',
            menu: [],
          },
          {
            label: 'CPO Management',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${EOC_BASE_URL}/po/items-sheet${token ? `?token=${token}` : ''}`;
            },
            videoUrl: 'https://cdn.moglix.com/mogliverse/2.2%20Suppliers%20View.mp4',
            menu: [],
          },
          {
            label: 'Reports',
            url: () => '',
            videoUrl: '',
            menu: [
              {
                label: 'RFQ Pendency',
                url: () => {
                  const token = encodeTokenForUrl(AuthService.getToken());
                  return `${EOC_BASE_URL}/reports/rfq-pendency${token ? `?token=${token}` : ''}`;
                },
                videoUrl: '',
                menu: [],
              },
              {
                label: 'ARC Performance',
                url: () => {
                  const token = encodeTokenForUrl(AuthService.getToken());
                  return `${EOC_BASE_URL}/reports/arc-performance${token ? `?token=${token}` : ''}`;
                },
                videoUrl: '',
                menu: [],
              },
            ],
          },
        ],
      },
      {
        label: 'Supplier Order Management',
        url: () => '',
        videoUrl: '',
        menu: [
          {
            label: 'RFQ',
            url: () => '',
            videoUrl: '',
            disable: true,
            menu: [],
          },
          {
            label: 'SPO',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${SCM_BASE_URL}/auth-validate/${token}${token ? `?tabgroup=SPO&tabname=purchase` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/2.+SCM-+Create+SPO.mp4',
            menu: [],
          },
          {
            label: 'Reports',
            url: () => '',
            videoUrl: '',
            disable: true,
            menu: [],
          },
        ],
      },
    ],
  },
  {
    label: 'Supply Chain Management',
    icon: icons.supplyChain,
    url: () => '',
    bgColor: 'bg-[#C1E7F1]',
    menu: [
      {
        label: 'WMS',
        url: () => '',
        videoUrl: '',
        menu: [
          {
            label: 'STN',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${SCM_BASE_URL}/auth-validate/${token}${token ? `?tabgroup=STN&tabname=stn` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Inbounding',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${SCM_BASE_URL}/auth-validate/${token}${token ? `?tabgroup=INBOUNDING&tabname=inbounding` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Customer Invoicing',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${SCM_BASE_URL}/auth-validate/${token}${token ? `?tabgroup=CUSTOMER_INVOICING&tabname=customer_invoicing` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Outbounding',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${SCM_BASE_URL}/auth-validate/${token}${token ? `?tabgroup=OUTBOUNDING&tabname=outbounding` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Shipping',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${SCM_BASE_URL}/auth-validate/${token}${token ? `?tabgroup=SHIPPING&tabname=shipping` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Logistics Partners',
            url: () => `https://coms.moglix.com/`,
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Runner Dashboard',
            url: () => `https://supplychain.moglix.com/`,
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Reports',
            url: () => '',
            videoUrl: '',
            menu: [
              {
                label: 'Inventory',
                url: () => `${SCM_BASE_URL}/warehousemanagement/inventory`,
                videoUrl: '',
                menu: [],
              },
              {
                label: 'Stock Levels',
                url: () => '',
                videoUrl: '',
                disable: true,
                menu: [],
              },
              {
                label: 'Inventory Aging Reports',
                url: () => '',
                videoUrl: '',
                disable: true,
                menu: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    label: 'Finance & Working Capital',
    icon: icons.financeWorkingCap,
    url: () => '',
    bgColor: 'bg-[#FAEEC8]',
    menu: [
      {
        label: 'Account Payout',
        url: () => '',
        videoUrl: '',
        menu: [
          {
            label: 'Supplier AP',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=supplier-payout/suppliers` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/Finance-+Add+Supplier+on+AP+Screen.mp4',
            menu: [],
          },
          {
            label: 'Payouts',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=payout/payout-sheets` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/Finance-+Create+payout+bank+sheet+%26+update+UTR+Manually.mp4',
            menu: [],
          },
          {
            label: 'Advance PO',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=advance-term-po` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/Finance-+Advance+PO.mp4',
            menu: [],
          },
        ],
      },
      {
        label: 'Account Receivables',
        url: () => '',
        videoUrl: 'https://cdnx1.moglix.com/videos/training/FINANCE+AR.mp4',
        menu: [
          {
            label: 'Customer AR',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=ar/customer-ar` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/FINANCE+AR.mp4',
            menu: [],
          },
          {
            label: 'Invoice Payment Mapping',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=ar/payment-mapping/table-list` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Customer Returns',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=ar/customer-cn/lists` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/Finance-+Create+customer+CN_DN_price.mp4',
            menu: [],
          },
        ],
      },
      {
        label: 'NetSuite',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=netsuite/process-record` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
      {
        label: 'Reports',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=reports/tech-report` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
      {
        label: 'Bank to Bank Transfer',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=banktobank/payout-info` : ''}`;
        },
        videoUrl: 'https://cdnx1.moglix.com/videos/training/Finance-+Bank+to+Bank+Transfer.mp4',
        menu: [],
      },
      {
        label: 'LC/BG',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=lcbg` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
      {
        label: 'Interest Calculations',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=interest-calculations` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
      {
        label: 'Insights',
        url: () => {
          const token = encodeTokenForUrl(AuthService.getToken());
          return `${FINANCE_BASE_URL}/redirect/auth/validate/${token}${token ? `?returnUrl=abc` : ''}`;
        },
        videoUrl: '',
        disable: true,
        menu: [],
      },
    ],
  },
  {
    label: 'Master Data Management',
    icon: icons.masterDataManagement,
    url: () => '',
    bgColor: 'bg-[#DCC7F7]',
    menu: [
      {
        label: 'Company & Plant Management',
        url: () => '',
        videoUrl: '',
        menu: [
          {
            label: 'Request Credit Limit',
            url: () => `${CREDIT_LIMIT_BASE_URL}/login`,
            videoUrl: '',
            disable: false,
            menu: [],
          },
          {
            label: 'New Company Creation',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${EOC_BASE_URL}/account-services/companies/create-company${token ? `?token=${token}` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'New Plant Creation',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${EOC_BASE_URL}/account-services/plants/create-plant${token ? `?token=${token}` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Contract Management (ARC/PaaS/LIFT, TOD,etc.)',
            url: () => {
              const token = encodeTokenForUrl(AuthService.getToken());
              return `${EOC_BASE_URL}/account-services/companies/create-company${token ? `?token=${token}` : ''}`;
            },
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Credit Limit Utilization',
            url: () => '',
            videoUrl: '',
            disable: true,
            menu: [],
          },
        ],
      },
      {
        label: 'Suppliers & Vendor Management',
        url: () => '',
        videoUrl: '',
        menu: [
          {
            label: 'New Supplier Onboarding',
            url: () => `https://supplier.moglix.com/signup`,
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Contract Management (ARC, TOD, etc.)',
            url: () => '',
            videoUrl: '',
            disable: true,
            menu: [],
          },
        ],
      },
    ],
  },
  {
    label: 'Catalog Management',
    icon: icons.catalogManagement,
    url: () => {
      const token = encodeTokenForUrl(unescape(encodeURIComponent(AuthService.getMSToken())));
      return `${CATALOG_BASE_URL}/login/${token ? `?ref=${token}` : ''}`;
    },
    bgColor: 'bg-[#C8F7E7]',
    videoUrl: 'https://cdnx1.moglix.com/videos/training/Catalog+Create_MSN.webm',
    menu: [],
  },
  {
    label: 'Stakeholder Relationship Management',
    icon: icons.stakeholder,
    url: () => '',
    bgColor: 'bg-[#DCC7F7]',
    menu: [
      {
        label: 'CRM (Customer Relationship Management)',
        url: () => {
          const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
          return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_CRM}&board=${BOARD_ID_FOR_CRM_ACCOUNT}&refreshToken=${token}` : ''}`;
        },
        videoUrl: '',
        menu: [
          {
            label: 'Account Creation (Hunting)',
            url: () => {
              const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
              return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_CRM}&board=${BOARD_ID_FOR_CRM_ACCOUNT}&refreshToken=${token}` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/1.CRM-Account+Creation_Updation.mp4',
            menu: [],
          },
          {
            label: 'Contact Creation For Hunting',
            url: () => {
              const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
              return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_CRM}&board=${BOARD_ID_FOR_CRM_CONTACTS}&refreshToken=${token}` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/4.CRM-Hunter_tab.mp4',
            menu: [],
          },
          {
            label: 'Contact Creation For SOB',
            url: () => {
              const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
              return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_SOB}&board=${BOARD_ID_FOR_SOB_CONTACTS}&refreshToken=${token}` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/4.CRM-Hunter_tab.mp4',
            menu: [],
          },
          {
            label: 'Deal Creation For Hunting',
            url: () => {
              const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
              return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_CRM}&board=${BOARD_ID_FOR_CRM_DEALS}&refreshToken=${token}` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/2.CRM-Deal+Creation.mp4',
            menu: [],
          },
          {
            label: 'Manage Meeting',
            url: () => {
              const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
              return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_CRM}&board=${BOARD_ID_FOR_CRM_DEALS}&refreshToken=${token}` : ''}`;
            },
            videoUrl: 'https://cdnx1.moglix.com/videos/training/7.CRM-Meeting+Creation.mp4',
            menu: [],
          },
        ],
      },
      {
        label: 'SRM (Supplier Relationship Management)',
        url: () => {
          const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
          return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_SRM}&board=${BOARD_ID_FOR_SRM_SUPPLIER}&refreshToken=${token}` : ''}`;
        },
        videoUrl: 'https://cdnx1.moglix.com/videos/training/8.CRM-SRM+Management.mp4',
        menu: [],
      },
      {
        label: 'Mergers & Acquisitions',
        url: () => {
          const token = btoa(unescape(encodeURIComponent(AuthService.getMSToken())));
          return `${CRM_BASE_URL}/user/unified/success${token ? `?token=${token}&business=${BUSINESS_ID_FOR_MNA}&board=${BOARD_ID_FOR_MNA_SUPPLIER}&refreshToken=${token}` : ''}`;
        },
        videoUrl: '',
        menu: [],
      },
    ],
  },
  {
    label: 'Customer Support',
    icon: icons.customerSupport,
    url: () => '',
    bgColor: 'bg-[#F5C9DB]',
    disable: true,
    menu: [
      {
        label: 'Customer NPS',
        url: () => '',
        videoUrl: '',
        menu: [],
      },
      {
        label: 'Supplier NPS',
        url: () => '',
        videoUrl: '',
        menu: [],
      },
      {
        label: 'Issue Tracking',
        url: () => '',
        videoUrl: '',
        menu: [],
      },
    ],
  },
  {
    label: 'Settings & Customization',
    icon: icons.settingCustomization,
    url: () => '',
    bgColor: 'bg-[#C1E7F1]',
    disable: true,
    menu: [
      {
        label: 'User Management',
        url: () => '',
        videoUrl: '',
        menu: [
          {
            label: 'Regions and Teams',
            url: () => '',
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Users',
            url: () => '',
            videoUrl: '',
            menu: [],
          },
          {
            label: 'User Roles & Permissions',
            url: () => '',
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Account activity and login',
            url: () => '',
            videoUrl: '',
            menu: [],
          },
          {
            label: 'Delegation of Authority (DOA)',
            url: () => '',
            videoUrl: '',
            menu: [],
          },
          {
            label: 'RFQ DOA settings',
            url: () => '',
            videoUrl: '',
            menu: [],
          },
        ],
      },
      {
        label: 'Dashboard customization options',
        url: () => '',
        videoUrl: '',
        menu: [],
      },
      {
        label: 'Alerts & Notifications',
        url: () => '',
        videoUrl: '',
        menu: [],
      },
    ],
  },
];